import React, { useState, useEffect } from "react";
import classnames from "classnames";
import Styles from "./WeGrownLot.module.scss";
import LocatorCar from "@vahak/core/dist/icons/top_view_truck.svg";
import LocatorPin from "@vahak/core/dist/icons/location_blue.svg";
import { useIntersect } from "@vahak/core/dist/hooks/useIntersect";
import AppImg from "components/utils/AppImg";
import { getTransporterFigure, getTransporterFigureTypes } from "@vahak/core/dist/methods/getTransporterFigure";
import { getDownloadsFigure, getDownloadsFigureTypes } from "@vahak/core/dist/methods/getDownloadsFigure";
import { PLATFORM_STATS } from "@vahak/core/dist/constants/platformStats";

const WeGrownLot = ({ isMobile }: { isMobile: boolean }) => {
    const [refMap, setRefMap] = useState(false);

    const [dotCount, setDotCount] = useState(0);

    const { entry: interSectionObjMap, setNode: mapRefCallback } = useIntersect({
        rootMargin: isMobile ? "-60px" : "74px",
        threshold: 0
    });

    useEffect(() => {
        if (interSectionObjMap?.intersectionRatio === 0) {
            setRefMap(false);
        } else {
            setRefMap(true);

            const interval = setInterval(() => {
                if (dotCount < 90) {
                    setDotCount((prevCount) => prevCount + 1);
                } else {
                    clearInterval(interval);
                }
            }, 50);

            return () => {
                clearInterval(interval);
            };
        }
    }, [interSectionObjMap, dotCount]);
    return (
        <section className={classnames(Styles.weGrownlotSection, "flipAnimate", refMap ? Styles.curveAnim : "")}>
            <div className="container">
                <div className={Styles.heading}>
                    <h2>
                        We’ve grown a lot since{" "}
                        <span data-hover="We Started" className="indaiText">
                            We Started
                        </span>
                    </h2>
                </div>

                <div className={Styles.indiaMaprow}>
                    <div className={Styles.indiaMapCol}>
                        <div className={Styles.imgBox} ref={mapRefCallback}>
                            <AppImg
                                src={`indiaMap.aeffd640-Mobile.png`}
                                alt="our reach"
                                width={isMobile ? "330" : "540"}
                                height={isMobile ? "353" : "578"}
                                layout="responsive"
                            />
                            <div className={Styles.lorryIcon}>
                                <LocatorCar width="60" height="61" />
                            </div>
                            <span className={Styles.locatorPin}>
                                <LocatorPin width="64" height="64" />
                            </span>
                            <span className={Styles.locatorPin}>
                                <LocatorPin width="64" height="64" />
                            </span>
                            <span className={Styles.locatorPin}>
                                <LocatorPin width="64" height="64" />
                            </span>
                            <span className={Styles.locatorPin}>
                                <LocatorPin width="64" height="64" />
                            </span>
                            <span className={Styles.locatorPin}>
                                <LocatorPin width="64" height="64" />
                            </span>
                            <span className={Styles.locatorPin}>
                                <LocatorPin width="64" height="64" />
                            </span>

                            {dotCount > 0 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 1 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 2 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 3 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 4 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 5 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 6 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 7 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 8 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 9 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 10 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 11 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 12 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 13 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 14 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 15 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 16 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 17 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 18 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 19 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 20 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 21 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 22 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 23 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 24 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 25 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 26 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 27 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 28 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 29 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 30 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 31 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 32 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 32 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 33 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 34 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 36 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 37 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 38 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 39 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 40 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 41 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 42 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 43 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 44 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 45 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 46 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 47 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 48 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 49 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 50 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 50 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 51 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 52 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 53 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}

                            {dotCount > 54 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 55 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 56 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 57 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 58 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 59 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 60 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 61 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 62 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 63 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 64 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 65 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 66 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 67 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 68 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 69 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 70 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 71 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 72 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 73 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 73 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 74 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 75 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 76 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 77 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                            {dotCount > 78 ? (
                                <div className={Styles.dot}>
                                    <span></span>
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                    <div className={Styles.grownDtlCol}>
                        <div className={Styles.grownBoxes}>
                            <div className={Styles.grownBox}>
                                <h3>{PLATFORM_STATS.cities.label}</h3>
                                <p>Cities Across India</p>
                            </div>
                            <div className={Styles.grownBox}>
                                <h3>{PLATFORM_STATS.bookings.lakhs}</h3>
                                <p>Bookings done</p>
                            </div>
                            <div className={Styles.grownBox}>
                                <h3>{getTransporterFigure(getTransporterFigureTypes.LAKHS)}</h3>
                                <p>Transporters Network</p>
                            </div>
                            <div className={Styles.grownBox}>
                                <h3>{getDownloadsFigure(getDownloadsFigureTypes.MILLIONS)}</h3>
                                <p>Downloads</p>
                            </div>

                            <div className={Styles.grownBox}>
                                <h3>8+</h3>
                                <p>Local Languages</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WeGrownLot;
